import { ApolloClient, InMemoryCache } from '@apollo/client'

const client = new ApolloClient({
  uri: 'https://ap-south-1.cdn.hygraph.com/content/cmf47hpdb01lp07w6yjfm682w/master',
  cache: new InMemoryCache(),
})


export { client }